import * as React from "react";
import {cx} from "emotion";

import "./advance-search-dropdown.scss";

import {Dropdown} from "@Common/ui-components/dropdown/dropdown";

import {AdvanceForm} from "../advance-form/advance-form";

export const AdvanceSearchDropdown = ({tags, freeText, next}) => Dropdown({
    renderToggle: next,
    renderExpand: ({position, width, close, domRef}) => (
        <div className={cx("advance-search-dropdown-7o2")} ref={domRef}>
            <div
                className={cx("box")}
                style={{
                    ...position,
                    ...position.top && {
                        top: position.top + 16,
                    },
                    minWidth: width,
                }}
            >
                {AdvanceForm({
                    onClose: close,
                    tags,
                    forceSearchable: freeText.value != "",
                })}
            </div>
        </div>
    ),
});